import Cookie from 'js-cookie';

(function () {
    const cookieName = 'lang-question-dont-ask';

    if (Cookie.get(cookieName)) {
        return;
    }

    setTimeout(function () {
        $('#lang_switch-question').removeClass('hide');
    }, 500);

    const dontAsk = () => {
        Cookie.set(cookieName, '1', { expires: 366, path: '/', secure: false });
    };

    $('.lang_switch-question .js-answer-no').click(function () {
        $('.lang_switch-question').hide();
        dontAsk();
    });

    $('.lang_switch-question .js-answer-yes').click(function () {
        $('.js-lang-form-ua .js-action').click();
        dontAsk();
    });
})();
